export default __webpack_public_path__ + "static/media/starts.fb790a46.svg";